import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';
import TextAnswer from '@/components/shared/answer-types/text/text.vue';

export default {
    name: 'RaceAdmin',
    props: {
        id: [Number, String],
        isAdminRequest: Boolean,

    },
    components: {
        [Popover.name]: Popover,
        'text-answer': TextAnswer
    },
    computed: {
    },
    data() {
        return {
            isProcessing: false,
            newUserTiIdOrEmail: null,
            users: []
        };
    },
    methods: {
        showWarning(message) {
            if (!message) {
                message = 'Warning!';
            }
            this.$notify({
                message: message,
                type: 'warning',
                timeout: 5000
            });
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        cancel() {
            this.load();
        },
        load() {
            var self = this;
            self.isProcessing = true;
            request.getRaceAdmins(self.id, self.isAdminRequest)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        if (response.body.outputData && response.body.outputData.length) {
                            self.users = response.body.outputData;
                        }
                        else {
                            self.users = [];
                        }
                    } else {
                        self.$showError();
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        save() {
            self = this;
            self.isProcessing = true;
            request.setRaceAdmins(self.id, self.isAdminRequest, self.users)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.newUserTiIdOrEmail = null;
                    } else {
                        if (response && response.body && response.body.message) {
                            self.$showError(response.body.message);
                        }
                        else {
                            self.$showError();
                        }
                    }
                    self.cancel();
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        remove(id) {
            this.users = this.users.filter(x => x.id != id);
            //this.showWarning('Please click "Save Changes" to save new list of race admins')
        },
        add() {
            self = this;
            if (!self.newUserTiIdOrEmail) {
                self.$showError("Please enter email or TI number")
                return;
            }
            self.isProcessing = true;

            request.getMemberByLoginOrTiID(self.newUserTiIdOrEmail)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body &&
                        response.body.isSuccess &&
                        response.body.outputData &&
                        response.body.outputData["TI Number"]) {

                        var model = {};
                        model["id"] = response.body.outputData["Id"];
                        model["email"] = response.body.outputData["Email"];
                        model["firstName"] = response.body.outputData["First Name"];
                        model["lastName"] = response.body.outputData["Last Name"];
                        model["phone"] = response.body.outputData["Phone"];
                        model["tiIdNumber"] = response.body.outputData["TI Number"];

                        var isAlready = self.users.filter(u => u.tiIdNumber == model.tiIdNumber)
                        if (isAlready.length) {
                            self.$showError("This user is already on the list of race admins and can't be add twices");
                        } else {
                            self.users.push(model);
                            self.newUserTiIdOrEmail = null;
                        }
                    } else {
                        self.$showError("User is not found. Check query and try again");
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        }
    },
    mounted() {
        this.init();
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-admin/race-admin.js